// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UserPreferences from '../../objects/UserPreferences';
import LocationAnalysisItemOrigin from '../../enums/LocationAnalysisItemOrigin';
import LocationAnalysisItem from '../../objects/LocationAnalysisItem';
import { dealAreaFields, ringFromPolygonParam } from '../../helpers/Util';

/**
 * @typedef Props
 * @property {string} title
 * @property {number[]} coordinates
 * @property {function} onClose
 * @property {object} [dealFeature]
 * @property {function} [onOpenPointInfo]
 * @property {object} bus
 *
 * @param {Props} props
 */
class InfoBubbleSimple extends React.Component {
    constructor(props) {
        super(props);
    }

    openMoreInfo = () => {
        const { bus, dealFeature, onOpenPointInfo } = this.props;
        const properties = dealFeature.properties;

        bus.emit('TOGGLE_INSIGHT_PANEL', { newValue: true });

        const analysisTypeId = properties.profile === 'driving' ? 'DRIVING_TIME' : 'RADIUS';
        const selection = JSON.parse(properties.selection);

        const newLocationAnalysisItem = new LocationAnalysisItem({
            type: properties.pointType,
            id: properties.facilityId,
            value: properties.title,
            point: {
                lng:
                    properties.originalLng != null
                        ? properties.originalLng
                        : dealFeature.geometry.coordinates[0],
                lat:
                    properties.originalLat != null
                        ? properties.originalLat
                        : dealFeature.geometry.coordinates[1],
            },
            itemOrigin: LocationAnalysisItemOrigin.LIBRARY_LAYER_FEATURE,
            analysisTypeId,
            selection,
            dealId: properties.id,
            listId: properties.listId,
            // A stored shape rides along on any deal, so it can be switched back to.
            ...(properties.polygon ? { ring: ringFromPolygonParam(properties.polygon) } : {}),
            ...(properties.profile === 'polygon' ? dealAreaFields(properties) : {}),
        });

        const visualReportProps = {
            report: 'market-profile',
            pointType: properties.pointType,
            facilityId: properties.facilityId,
        };

        onOpenPointInfo(newLocationAnalysisItem, visualReportProps);
    };

    render() {
        const { title, coordinates, onClose, dealFeature } = this.props;
        return (
            <div className="marker-content">
                <div className="marker-content__heading">
                    <h5 className="selectable-text" title={title}>
                        {title}
                    </h5>
                    <button
                        className="dragonfly-popup-close-button"
                        type="button"
                        aria-label="Close popup"
                        onClick={onClose}
                    >
                        ×
                    </button>
                </div>
                <div className="marker-content__link">
                    <a
                        className="google-map-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://www.google.com/maps/search/?api=1&query=${[...coordinates]
                            .reverse()
                            .join(',')}`}
                    >
                        Open in Google maps
                    </a>
                </div>
                {dealFeature && (
                    <div
                        className={classNames(
                            'flex-it center geojson-point-popup__footer space-around',
                        )}
                    >
                        <button onClick={this.openMoreInfo} className="btn btn-details">
                            View more details
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

InfoBubbleSimple.propTypes = {
    title: PropTypes.string.isRequired,
    coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
    onClose: PropTypes.func.isRequired,
    dealFeature: PropTypes.object,
    onOpenPointInfo: PropTypes.func,
    bus: PropTypes.object.isRequired,
};

InfoBubbleSimple.defaultProps = {
    title: undefined,
    coordinates: [],
    onClose: undefined,
    bus: undefined,
};

export default InfoBubbleSimple;
